import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CardEvent, CardEventType, CommonIndexedPagination, MasterViewEngineEvent, PlatformResponse } from '@iot-platform/models/common';

@Component({
  selector: 'oyan-ui-site-stocks',
  templateUrl: './site-stocks.component.html',
  styleUrls: ['./site-stocks.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteStocksComponent {
  stocksAsPlatformResponse = input<PlatformResponse>();
  loading = input<boolean>(false);
  userPermissions = input<{ key: string; value: boolean }[]>([]);
  ofTypeBlyott = input<boolean>();
  canUpdateSite = input<boolean>();

  dispatchMasterViewEngineEvent = output<MasterViewEngineEvent>();
  pageChange = output<CommonIndexedPagination>();
  dispatchEvent = output<CardEvent>();

  get hasStocks(): boolean {
    return this.stocksAsPlatformResponse()?.data && !!this.stocksAsPlatformResponse()?.data.length;
  }

  onPageChange(pagination: CommonIndexedPagination): void {
    this.pageChange.emit(pagination);
  }

  onDispatchMasterViewEngineEvent(event: MasterViewEngineEvent): void {
    this.dispatchMasterViewEngineEvent.emit(event);
  }

  onSyncStocks(): void {
    this.dispatchEvent.emit({
      eventType: CardEventType.SYNCHRONIZE_STOCKS,
      data: null
    });
  }
}
